import { useContext } from 'react';
import WebUserContext from './WebUserContext';

const useWebUser = () => {
    return useContext(WebUserContext);
}

export default useWebUser;